<template>
  <form role="form" class="upload-box" enctype="multipart/form-data" @submit.prevent="onSubmit">
    <div class="form-group">
      <div
        class="drop-area"
        @ondragover="onChange"
        :class="dragging ? 'dropAreaDragging' : ''"
        @dragenter="dragging=true"
        @dragend="dragging=false"
        @dragleave="dragging=false">
        <h3>Drop aif files here</h3>
        <p>or click to upload</p>
        <input
          type="file"
          id="items"
          name="items[]"
          required
          multiple
          @change="onChange" />
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    dropAreaPrimaryMessage: {
      type: String,
    },
    dropAreaSecondaryMessage: {
      type: String,
      default: 'or click to upload'
    },
  },

  data() {
    return {
      dragging: false,
      items: [],
      itemsAdded: '',
      itemsNames: [],
      itemsSizes: [],
      itemsTotalSize: '',
      formData: '',
      successMsg: '',
      errorMsg: '',
      isLoaderVisible: false,
    }
  },

  methods: {
    onChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      for (let x in files) {
        if (!isNaN(x)) {
          this.$emit('upload', files[x])
        }
      }
    },

    removeItems() {
      this.items = '';
      this.itemsAdded = '';
      this.itemsNames = [];
      this.itemsSizes = [];
      this.itemsTotalSize = '';
      this.dragging = false;
    },
  }
}
</script>

<style scoped lang="scss">
.upload-box {
  position: relative;
  margin: 2em;

  h3 {
    padding: 0;
    margin: 0;
  }

  .drop-area {
    position: relative;
    height: 200px;
    border: 5px solid orange;
    border-radius: 1em;
    background: #eee;
    text-align: center;
    font-size: 2em;
    padding-top: 80px;

    input {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
</style>
